import React from "react";
function DownloadCSV() {
  return (
    <div>
      <a href={`/sample.csv`} download="sample.csv">
        Download Sample CSV
      </a>
    </div>
  );
}

export default DownloadCSV;
